module.exports = __webpack_public_path__ + "img/img7.9c4aedfe.png";